import React from 'react';

interface Props {
  width?: number | string;
  className?: string;
}

export const SSLCertificateBadge: React.FC<Props> = ({
  width = 100,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={width}
    height={typeof width === 'number' ? width * (100 / 100) : 'auto'}
    className={className}
  >
    <defs>
      <linearGradient
        id="SSLCertificateBadgea"
        x1={49.65}
        x2={50.94}
        y1={-0.96}
        y2={98.86}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          stopColor="#006838"
        />
        <stop
          offset={1}
          stopColor="#8dc63f"
        />
      </linearGradient>
    </defs>
    <circle
      cx={50}
      cy={48.32}
      r={46.62}
      fill="#e6e7e8"
    />
    <path
      fill="url(#SSLCertificateBadgea)"
      d="M91.18 5.72v40.31C91.18 71.79 73.74 93.5 50 100 26.27 93.5 8.82 71.79 8.82 46.03V5.71c4.97 3.23 10.91 5.09 17.27 5.09C35.62 10.8 44.17 6.62 50 0c5.83 6.62 14.38 10.8 23.91 10.8 6.36 0 12.3-1.87 17.27-5.08Z"
    />
    <path
      fill="#fff"
      d="m15.77 48.4 2.19-4.85c2.34 1.71 5.83 2.9 9.17 2.9 3.81 0 5.36-1.27 5.36-2.98 0-5.2-16.16-1.63-16.16-11.95 0-4.72 3.81-8.66 11.72-8.66 3.49 0 7.07.84 9.65 2.46l-1.98 4.88c-2.58-1.47-5.25-2.18-7.71-2.18-3.81 0-5.28 1.43-5.28 3.18 0 5.12 16.16 1.59 16.16 11.79 0 4.65-3.85 8.62-11.79 8.62-4.41 0-8.85-1.31-11.32-3.22Zm25.35 0 2.19-4.85c2.34 1.71 5.83 2.9 9.17 2.9 3.81 0 5.36-1.27 5.36-2.98 0-5.2-16.16-1.63-16.16-11.95 0-4.72 3.81-8.66 11.72-8.66 3.49 0 7.07.84 9.65 2.46l-1.98 4.88c-2.58-1.47-5.25-2.18-7.71-2.18-3.81 0-5.28 1.43-5.28 3.18 0 5.12 16.16 1.59 16.16 11.79 0 4.65-3.85 8.62-11.79 8.62-4.41 0-8.85-1.31-11.32-3.22Zm27.54-25.05h6.43V45.9h10.48v5.24H68.66v-27.8ZM20.4 60.57c0-2.34 1.78-4.05 4.19-4.05 1.22 0 2.28.42 3.01 1.23l-.73.71c-.61-.64-1.36-.94-2.23-.94-1.79 0-3.11 1.29-3.11 3.04s1.32 3.04 3.11 3.04c.87 0 1.62-.3 2.23-.95l.73.71c-.72.81-1.79 1.24-3.02 1.24-2.4 0-4.18-1.71-4.18-4.05Zm14.56 2.97v.98h-5.74v-7.91h5.58v.98h-4.45v2.43h3.97v.96h-3.97v2.55h4.61Zm7.13.98-1.71-2.43c-.16.01-.33.02-.5.02h-1.96v2.41h-1.13v-7.91h3.09c2.06 0 3.3 1.04 3.3 2.76 0 1.22-.63 2.1-1.74 2.5l1.88 2.66h-1.23Zm-.03-5.15c0-1.13-.76-1.77-2.2-1.77h-1.92v3.56h1.92c1.45 0 2.2-.66 2.2-1.79Zm4.42-1.78h-2.71v-.98h6.54v.98H47.6v6.93h-1.12v-6.93Zm5.07-.98h1.13v7.91h-1.13v-7.91Zm4.64.98v2.76h3.97v.97h-3.97v3.2h-1.13v-7.91h5.58v.98h-4.45Zm6.05-.98h1.13v7.91h-1.13v-7.91Zm9.25 6.93v.98h-5.74v-7.91h5.58v.98h-4.45v2.43h3.97v.96h-3.97v2.55h4.61Zm1.84-6.93h3.33c2.54 0 4.27 1.61 4.27 3.96s-1.73 3.96-4.27 3.96h-3.33v-7.91Zm3.27 6.93c1.96 0 3.21-1.2 3.21-2.97s-1.25-2.97-3.21-2.97h-2.14v5.94h2.14Z"
    />
    <path
      fill="#d1d3d4"
      d="M26.22 96.23H0l8.32-7.96L0 80.32h26.22v15.91zm47.56 0H100l-8.32-7.96 8.32-7.95H73.78v15.91z"
    />
    <path
      fill="#e6e7e8"
      d="M8.52 75.42h82.96v15.91H8.52z"
    />
    <path
      fill="#bcbec0"
      d="m8.52 91.33 17.7 4.9v-4.9H8.52zm82.96 0-17.7 4.9v-4.9h17.7z"
    />
    <path
      fill="#414042"
      d="M16.5 79.75v7.26h-1.35v-6.13h-1.54v-1.13h2.88Zm1.44 3.63c0-2.39 1.31-3.73 3.03-3.73s3.04 1.35 3.04 3.73-1.31 3.73-3.04 3.73-3.03-1.35-3.03-3.73Zm4.71 0c0-1.75-.68-2.56-1.68-2.56s-1.67.81-1.67 2.56.68 2.56 1.67 2.56 1.68-.81 1.68-2.56Zm2.28 0c0-2.39 1.31-3.73 3.03-3.73S31 81 31 83.38s-1.31 3.73-3.04 3.73-3.03-1.35-3.03-3.73Zm4.7 0c0-1.75-.68-2.56-1.68-2.56s-1.67.81-1.67 2.56.68 2.56 1.67 2.56 1.68-.81 1.68-2.56Zm2.17-1.71c0-1.19.69-1.99 1.73-1.99s1.74.79 1.74 1.99-.71 1.99-1.74 1.99-1.73-.8-1.73-1.99Zm2.62 0c0-.81-.33-1.27-.89-1.27s-.89.47-.89 1.27.35 1.27.89 1.27.89-.46.89-1.27Zm3.47-1.92h1.02l-4.96 7.26h-1.02l4.96-7.26Zm-1.33 5.34c0-1.19.69-1.99 1.73-1.99s1.74.8 1.74 1.99-.7 1.99-1.74 1.99-1.73-.8-1.73-1.99Zm2.62 0c0-.8-.34-1.27-.89-1.27s-.89.46-.89 1.27.34 1.27.89 1.27.89-.47.89-1.27Zm4.43 1.15.47-1.05c.58.47 1.5.8 2.4.8 1.13 0 1.61-.4 1.61-.94 0-1.57-4.31-.54-4.31-3.24 0-1.17.93-2.17 2.92-2.17.87 0 1.78.23 2.42.64l-.43 1.05c-.65-.38-1.37-.57-2-.57-1.12 0-1.58.44-1.58.99 0 1.54 4.3.54 4.3 3.2 0 1.16-.94 2.16-2.93 2.16-1.13 0-2.26-.35-2.86-.87Zm12.58-.36v1.13h-5.45v-7.26h5.3v1.13h-3.95v1.89h3.51v1.11h-3.51v2h4.1Zm.96-2.5c0-2.17 1.66-3.73 3.89-3.73 1.18 0 2.2.43 2.87 1.21l-.87.82c-.53-.57-1.18-.85-1.94-.85-1.5 0-2.59 1.06-2.59 2.55s1.09 2.55 2.59 2.55c.76 0 1.41-.28 1.94-.86l.87.83c-.67.79-1.69 1.21-2.88 1.21-2.22 0-3.88-1.56-3.88-3.73Zm7.95.46v-4.1h1.35v4.04c0 1.49.67 2.14 1.85 2.14s1.84-.64 1.84-2.14v-4.04h1.33v4.1c0 2.12-1.19 3.27-3.17 3.27s-3.18-1.15-3.18-3.27Zm13 3.17-1.48-2.13H74.7V87h-1.35v-7.26h2.99c1.91 0 3.09.98 3.09 2.58 0 1.1-.56 1.91-1.54 2.29L79.56 87h-1.45Zm-1.82-6.12H74.7v2.89h1.58c1.18 0 1.8-.54 1.8-1.45s-.61-1.44-1.8-1.44Zm10.11 4.99v1.13h-5.45v-7.26h5.3v1.13h-3.95v1.89h3.51v1.11h-3.51v2h4.1Z"
    />
  </svg>
);
